require('./css/stepHeader.scss');

class StepHeader {

    constructor(Survey, Utils, $sce){

      this.Survey = Survey;
      this.Utils = Utils;
      this.$sce = $sce;
    }
  
    // injection here
    static get $inject() {
      return [
        'Survey',
        'Utils',
        '$sce'
      ];
    }
    
    
    stepImageSrc() {
      return this.img ? (this.img) : '';
    }
    
    $onInit() {
      return (async () => {
        const school = this.Survey.getSchool();
        const location = this.Survey.getPhysicalLocation();
        if (school) {
          this.school = {
            name: school.name,
            address: location ? location.display : school.address,
          }
        }
        
        if (this.messageOnRight) {
          this.messageOnRight = this.$sce.trustAsHtml(this.messageOnRight)
        }
      })();
    }
  
    $onChanges() {
    }
  }
  
  
  module.exports = {
    template: require('./templates/stepHeader.html'),
    controllerAs: 'ctrl',
    controller: StepHeader,
    bindings: {
      stepNumber: '@',
      title: '@stepTitle',
      description: '@',
      img: '@?',
      school: '<?',
      location: '<?',
      messageOnRight: '<?'
    }
  };